export default __webpack_public_path__ + "static/fp-text-logo-white-81d8cc7eadeff3ded9b4eaae48a5ed06.svg";